export const UIAssistant = {
    "UI": {
        items: [
            //Changing system UI
            {
                heading: 'Changing system UI',
                permissions: ['System Admin'],
                tags: ['ui', 'ux', 'colour', 'font', 'icon'],
                sections: [
                    {
                        description: 'To update the the systems UI, Select the DrData facility',
                        styleAs: 'list',
                    },
                    {
                        description: 'From the menu select <b>UI/UX Customise</b>',
                        styleAs: 'list',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the customisation screen',
                        action: {
                            type: 'location',
                            value: '/sys-admin/ux/0',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}